
import { PricingDisplay } from "../PricingDisplay";
import { WelcomeFormValues } from "./types";
import { useNavigate } from "react-router-dom";
import { usePremiumUpgrade } from "../hooks/usePremiumUpgrade";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface WelcomePricingProps {
  onSubmit: (values: WelcomeFormValues) => Promise<void>;
  formValues: WelcomeFormValues;
}

export function WelcomePricing({ onSubmit, formValues }: WelcomePricingProps) {
  const navigate = useNavigate();
  const { handlePremiumUpgrade } = usePremiumUpgrade();
  const { toast } = useToast();

  const handlePremiumUpgradeClick = async () => {
    try {
      // First save the form data
      await onSubmit(formValues);
      
      // Then redirect to Stripe checkout
      await handlePremiumUpgrade();
    } catch (error) {
      console.error("Error during premium upgrade:", error);
      toast({
        title: "Error",
        description: "Failed to process upgrade. Please try again.",
        variant: "destructive",
      });
    }
  };

  const handleFreeClick = () => {
    // Save the form data first, then redirect to verse dashboard
    onSubmit(formValues).then(() => {
      navigate('/');
    });
  };

  return (
    <div className="w-full space-y-6 animate-fade-in">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-semibold text-app-text-primary transition-colors duration-300">Choose Your Plan</h2>
        <p className="text-app-text-secondary transition-colors duration-300">
          Hi {formValues.full_name}! Now let's set up your subscription.
        </p>
      </div>
      
      <PricingDisplay 
        context="welcome"
        onSubmit={handlePremiumUpgradeClick}
        formValues={formValues}
        onFreeClick={handleFreeClick}
      />
    </div>
  );
}
